import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { LUFTHANSA } from '../data/airlinesData';

export default function LufthansaPage() {
  return <AirlineDetailPage airline={LUFTHANSA} />;
}
